import { useRoutes } from 'react-router';
import { Navigate, useLocation } from 'react-router-dom';

const REDIRECT_QUERY_PARAM = 'redirect';

const AppComponentWrapper = ({ children, authPath, isAuth }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  searchParams.set(REDIRECT_QUERY_PARAM, encodeURIComponent(location.pathname));
  const authPathWithRedirect = `../${authPath}?${searchParams.toString()}`;

  return isAuth ? children : <Navigate to={authPathWithRedirect} replace />;
};

const AuthComponentWrapper = ({ children, appPath, isAuth }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirectSearchParam = searchParams.get(REDIRECT_QUERY_PARAM);
  const redirectPath = redirectSearchParam
    ? decodeURIComponent(redirectSearchParam)
    : `../${appPath}`;

  return isAuth ? <Navigate to={redirectPath} replace /> : children;
};

const AuthAppSwitch = ({
  isAuth,
  authComponent,
  appComponent,
  appPath = '',
  authPath = 'auth',
}) => {
  const AppComponent = appComponent;
  const AuthComponent = authComponent;

  const appPathExtended = appPath ? `${appPath.replace(/\/$/, '')}/*` : '/*';
  const authPathExtended = `${authPath}/*`;

  const routes = [
    // These are the same as the props you provide to <Route>
    {
      path: appPathExtended,
      index: true,
      element: (
        <AppComponentWrapper authPath={authPath} isAuth={isAuth}>
          <AppComponent />
        </AppComponentWrapper>
      ),
    },
    {
      path: authPathExtended,
      element: (
        <AuthComponentWrapper appPath={appPath} isAuth={isAuth}>
          <AuthComponent />
        </AuthComponentWrapper>
      ),
    },
    {
      path: '*',
      element: <Navigate to={isAuth ? appPath : authPath} replace />,
    },
  ];

  console.log(routes);

  return useRoutes(routes);
};

export default AuthAppSwitch;
